import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import moment from 'moment';
import { api } from './api';
import { getNewStateByAttr, getNewStateById } from './entities';
import { fetchFantasyEventGames } from './fantasyEventGames';
import { fetchFantasyEvents } from './fantasyEvents';
const initialState = {
    byDate: {},
    byId: {},
    byLeague: {},
    byProvider: {},
    bySeason: {},
    byStatus: {},
    byWeek: {},
    status: 'init'
};
export const fetchGames = createAsyncThunk('games/fetch', async (options, thunkApi) => {
    const requestOptions = Object.assign({}, options.game);
    requestOptions.gameTimeGt = moment().startOf('day').toISOString();
    if (options.configuration.weeklyLeagues.includes(options.game.league)) {
        if (moment().day() < options.configuration.previousWeekCutoffDay) {
            requestOptions.gameTimeGt = moment()
                .startOf('day')
                .subtract(options.configuration.gameDateRangeGT, 'weeks')
                .toISOString();
        }
    }
    else if (options.configuration.dailyLeagues.includes(options.game.league)) {
        if (moment().hour() < options.configuration.previousDayCutoffHour) {
            requestOptions.gameTimeGt = moment()
                .startOf('day')
                .subtract(options.configuration.gameDateRangeGT, 'days')
                .toISOString();
        }
    }
    if (options.game.league === 'PGA') {
        if (moment().day() > 4 || moment().day() === 0) {
            requestOptions.gameTimeGt = moment().startOf('day').subtract(3, 'days').toISOString();
        }
    }
    try {
        return await (await api.instance).fetchGames(requestOptions);
    }
    catch (error) {
        return thunkApi.rejectWithValue(error);
    }
});
export const fetchOpenAndClosedGames = (configuration, league, currentSeason, date) => {
    const options = { league, season: currentSeason };
    if (date) {
        if (league) {
            options.gameTimeGt = moment.utc(date).subtract(configuration.gameDateRangeGT, 'days').toISOString();
            options.gameTimeLt = moment.utc(date).add(configuration.gameDateRangeLT, 'days').toISOString();
        }
    }
    else {
        if (league) {
            options.gameTimeGt = moment.utc().subtract(configuration.gameDateRangeGT, 'days').toISOString();
            options.gameTimeLt = moment.utc().add(configuration.gameDateRangeLT, 'days').toISOString();
        }
    }
    return fetchGames({ configuration, game: options });
};
const getNewStateByDateAttrPredicate = (game) => {
    return moment(game.gameTime).format('YYYY-MM-DD');
};
const applyGamesState = (state, games) => {
    state.byId = getNewStateById(state.byId, games);
    state.byDate = getNewStateByAttr(state.byId, getNewStateByDateAttrPredicate);
    state.byLeague = getNewStateByAttr(state.byId, 'league');
    state.byProvider = getNewStateByAttr(state.byId, 'provider');
    state.bySeason = getNewStateByAttr(state.byId, 'season');
    state.byStatus = getNewStateByAttr(state.byId, 'gameStatus');
    state.byWeek = getNewStateByAttr(state.byId, 'week');
};
const gamesSlice = createSlice({
    name: 'games',
    initialState,
    reducers: {
        setGames: (state, action) => {
            applyGamesState(state, action.payload);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchGames.fulfilled, (state, action) => {
            applyGamesState(state, action.payload.games);
            state.status = 'success';
        })
            .addCase(fetchFantasyEvents.fulfilled, (state, action) => {
            applyGamesState(state, action.payload.games);
        })
            .addCase(fetchFantasyEventGames.fulfilled, (state, action) => {
            action.payload.forEach((fantasyEventGame) => {
                state.byId = getNewStateById(state.byId, fantasyEventGame.games);
            });
        })
            .addCase(fetchGames.pending, (state) => {
            state.status = 'fetching';
        })
            .addCase(fetchGames.rejected, (state) => {
            state.status = 'error';
        });
    }
});
export const gamesReducer = gamesSlice.reducer;
